<template>
  <section class="shopping-present">
    <div class="shopping-form">
      <h2 class="shopping-form__title">
        {{ subscribeData.name }}
      </h2>
      <p class="shopping-form__for">
        {{ subscribeData.detailText }}
      </p>

      <form class="shopping-form__form" action="" @submit.prevent="addSubscriber">
        <!--                <def-input-->
        <!--                    placeholder="name"-->
        <!--                />-->
        <!--                <def-email />-->
        <div v-for="input in subscribe.inputs">
          <component
            :is="input.component"
            :name="input.name"
            :placeholder="input.placeholder"
            :required="true"
            :value="getInputValue(input.component)"
          >
            <!--                        {{ input.error }}-->
          </component>
        </div>
        <!--                При поступлении макетов сделать нормально-->
        <div v-if="response && response.status" class="shopping-form__success">
          <span>{{ response.text }}</span>
        </div>
        <div v-else-if="response.text" class="shopping-form__error">
          <span>{{ response.text }}</span>
        </div>

        <button v-if="messages" type="submit" class="shopping-form__subscribe">
          <svg>
            <use xlink:href="#svg-message"></use>
          </svg>
          <!--                    subscribe-->
          {{ messages.button }}
        </button>
      </form>
      <p v-if="messages" class="shopping-form__text">
        {{ messages.agreement }}
      </p>
    </div>
    <div>
      <!--            <img-->
      <!--                src="/local/templates/love-you/images/shopping.png"-->
      <!--                alt="shopping"-->
      <!--                class="shopping-present__img"-->
      <!--            >-->
      <!--            <DefImg-->
      <!--                :result="subscribe.image"-->
      <!--            />-->
      <DefPicture v-if="subscribeData.pictures" :result="subscribeData.pictures" />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefEmail from '@components/Def/DefEmail/DefEmail.vue';
import useModal from '@use/useModal/useModal';
import ShoppingPresentSuccess from '@components/modals/ShoppingPresentSuccess.vue';

export default {
  name: 'ShoppingPresent',
  components: { DefPicture, DefInput, DefEmail },
  props: ['result'],
  data() {
    return {
      response: {},
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      subscribe: ({ results }) => results?.subscribe,
      subscribeData: ({ results }) => results?.subscribe?.data,
      messages: ({ results }) => results?.subscribe?.messages,
      authInfo: ({ personal }) => personal.data?.authInfo,
    }),
    ...mapGetters({
      lang: 'getRequestLang',
    }),
  },

  mounted() {
    // console.log(this.$parent);
  },
  beforeUnmount() {
    const subscribeId = this?.subscribe?.data?.id;
    if (subscribeId) window.sessionStorage.setItem(`isSubscribeModal${subscribeId}WasShown`, true);
  },
  methods: {
    async addSubscriber({ target }) {
      const formData = new FormData(target);
      try {
        const routes = this.subscribe?.routes?.addSubscriber;
        const {
          path,
          'params-example-data': { action },
        } = routes;

        const { id, dontSendMail, mailTemplate } = this?.subscribe?.data;

        if (action && path) {
          formData.append('action', action);
          formData.append('subscribeBannerId', id);
          formData.append('dontSendMail', dontSendMail);
          formData.append('mailTemplate', mailTemplate);
          formData.append('LANGUAGE_ID', this.lang.LANGUAGE_ID);

          const { status, data } = await axios.post(path, formData);

          if (status !== 200) {
            throw `bad request response status: ${status} \n url: ${path}`;
          }

          this.response = data?.response;

          if (this.response.status) {
            await this.modal.hide();
            this.modal.show(
              ShoppingPresentSuccess,
              { result: this.response.text },
              { width: '340px' }
            );
          }
        } else {
          throw `action: ${action} or path: ${path} is empty`;
        }
      } catch (err) {
        console.error(err);
      }
    },
    getInputValue(component) {
      switch (component) {
        case 'def-email':
          return this.authInfo?.user_email;
        case 'DefPhone':
          return this.authInfo?.user_phone_number;
        case 'def-input':
          return this.authInfo?.user_name;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shopping-present {
  display: grid;
  position: relative;
  @include point-md {
    grid-template-columns: 1fr;
  }
  @include point-lg {
    grid-template-columns: repeat(2, 1fr);
  }
  ::v-deep {
    .def-picture__image {
      //display: block;
      //max-width: 100%;
      width: 100%;
    }
  }
}

.shopping-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  background-color: #618eaf;
  padding: 40px 24px;
  @include point-lg {
    padding: 40px 80px;
  }

  &__title {
    font-weight: 600;
    font-size: rem(18);
    line-height: 120%;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 12px;
    @include point-md {
      font-size: rem(24);
      line-height: 100%;
    }
  }

  &__for {
    font-size: rem(12);
    line-height: 100%;
    color: #ffffff;
    margin-bottom: 24px;
  }

  &__subscribe {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #fff;
    background-color: transparent;
    color: #fff;
    height: 44px;
    padding: 0 40px;
    font-weight: 600;
    font-size: rem(12);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    width: 100%;
    @include point-md {
      width: auto;
    }

    svg {
      display: block;
      width: 16px;
      height: 16px;
      fill: #fff;
      margin-right: 8px;
    }
  }

  &__text {
    font-size: rem(10);
    line-height: 120%;
    color: rgba(215, 211, 208, 0.6);
  }

  &__form {
    display: grid;
    grid-row-gap: 24px;
    margin-bottom: 16px;
  }

  &__success {
    color: #0ab35e;
  }

  &__error {
    color: #c60606;
  }
  //::v-deep{
  //    .def-input{
  //        //margin-bottom: 24px;
  //    }
  //    .def-email__input,
  //    .def-input__input,
  //    .def-phone__input{
  //        background-color: transparent;
  //        color: #fff;
  //        &::placeholder{
  //            color: #fff;
  //        }
  //        &::-internal-autofill-selected{
  //            background-color: transparent;
  //        }
  //    }
  //}
  :deep(.def-email__input),
  :deep(.def-input__input) {
    background-color: transparent;
    color: #fff;
    &::placeholder {
      color: #fff;
    }
    &::-internal-autofill-selected {
      background-color: transparent;
    }
  }
  :deep(.def-input),
  :deep(.def-email) {
    width: 100%;
    margin-bottom: 2px;
    background-color: transparent;
  }
  :deep(.def-input__input, .def-email__input) {
    background-color: transparent;
    border-bottom-color: rgba(215, 211, 208, 0.6);
    color: #fff;
    width: 100%;
  }
  :deep(.def-input__placeholder) {
    color: #fff;
  }
  :deep(.def-email__label) {
    color: #fff;
  }
  //:deep {
  //    .def-input,
  //    .def-email {
  //        width: 100%;
  //        margin-bottom: 2px;
  //    }
  //
  //    .def-input__input,
  //    .def-email__input {
  //        background-color: transparent;
  //        border-bottom-color: rgba(215, 211, 208, 0.6);
  //        color: #fff;
  //        width: 100%;
  //    }
  //}
}
</style>
